import React, { Component } from 'react';
import moment from 'moment';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import formDataPostService from '../../../services/httpformData';
import html2PDF from 'jspdf-html2canvas';
let dollarIndianLocale = Intl.NumberFormat('en-IN');
const { base_url } = networkList;
class PatientCheckList_preview extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: {},
            tableData : []
        }
    }
    componentDidMount() {        
        let { cash_preview_data, } = this.props
        this.setState({ 'data': cash_preview_data})
        console.log('cash_preview_data1',cash_preview_data)
        this.getCheckList();
    }

    getCheckList () {
        console.log("here");
        try {
          let user_data;
          if (
            localStorage.getItem('user_data') !== null &&
            localStorage.getItem('user_data') !== undefined &&
            localStorage.getItem('user_data') !== ''
          ) {
            user_data = JSON.parse(localStorage.getItem('user_data'));
          }
          postService('getFCChecklist', 'POST', {
            data: { unit_id: user_data['unitid'] ? user_data['unitid'] : '' }
          })
            .then(res => {
                if (res.status) {
                    this.setState({ tableData: res.data[0].data }, () => {
                        this.checklist_generation();
                    });
              } else {
                this.setState({ tableData: [], fetching: false });
              }
            })
            .catch(error => {
              console.log(error);
              this.setState({ fetching: false });
            });
        } catch (error) {
          console.log(error);
          this.setState({ fetching: false });
        }
      };

      checklist_generation() {
        let {cash_preview_data} = this.props
        const counsellingID = Math.floor(100000 + Math.random() * 900000);
        console.log("counsellingID",counsellingID);
        console.log("patientChecklistPreview!!!!!!!!");
        let This=this
        const tableHeadData = `patientChecklistPreview`;
        const patientChecklistPreview = document.getElementById(tableHeadData);
        console.log("patientChecklistPreview1111---------",patientChecklistPreview);
        console.log("cash_preview_data[ip_no]",cash_preview_data['ip_no'])
                    if (patientChecklistPreview!==null&&patientChecklistPreview!==''&&patientChecklistPreview!==undefined&&
                        cash_preview_data['ip_no']!==null&&cash_preview_data['ip_no']!==''&&cash_preview_data['ip_no']!==undefined){
                            console.log("patientChecklistPreview========",patientChecklistPreview)
                            console.log("cash_preview_data['ip_no']",cash_preview_data['ip_no'])
                            html2PDF(patientChecklistPreview,{
                                image: { type: 'png', quality: 0.20 },
                                jsPDF: { format: 'a4' },
                                html2canvas: {
                                    scrollX: 0,
                                    scrollY: -window.scrollY,
                                    useCORS: true,
                                },
                                imageType: 'image/jpeg',
                                output: './images/generate_checklist.pdf',
                                success: function (pdf) {
                                            const blob2 = pdf.output('blob');
                                            const form_data = new FormData();
                                            console.log("patientChecklistPreview++++++++++",patientChecklistPreview)
                                            form_data.append('upfileforchecklist', blob2);
                                            form_data.append('umr', cash_preview_data['umr_no']);
                                            form_data.append('counselling_id', counsellingID);
                                            form_data.append('doctor_name', cash_preview_data['doctor_name']);
                                            form_data.append('patient_name', cash_preview_data['patient_name']);
                                            form_data.append('counselling_date', cash_preview_data['counselling_date']);
                                            form_data.append('speciality_id', cash_preview_data['speciality_id']);
                                            // form_data.append('is_digital_sig_required', isGenerateSign);
                                            // form_data.append('phone_no', digiSignPhone);
                                            form_data.append('counsellorName', JSON.parse(localStorage.getItem('user')));

                                            console.log("patientChecklistPreview111111",patientChecklistPreview)
                                            formDataPostService('fileUploadforChecklist', 'POST', form_data).then(res => {
                                                if (res.status) {
                                                    console.log("patientChecklistPreview222222",patientChecklistPreview)
                                                    localStorage.setItem('completed_counselling_date', moment());
                                                    // This.props.next();
                                                    // This.setState({ loadding: false });
                                                    console.log("patientChecklistPreview33333333333",patientChecklistPreview)
                                                    
                                                }
                                            });
                                        }
                                    }); 
                            }
      }

    render() {
        let { tableData} = this.state
        let user_data
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        return (
            <div id='patientChecklistPreview'>
                <React.Fragment>
                    <div className="fc-patient-copy">
                        <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn" style={{display:'flex',flexDirection:'column'}}>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%',marginBottom: '20px' }}>
                                <div>
                                    <img src={`/assets/images/units-logo/${user_data["unitid"] && user_data["unitid"]}.png`} alt="Kims" style={{ width: '200px', height: 'auto' }} />
                                </div>
                            </div>
                            <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', textAlign: 'left',marginTop: '20px' }}>
                                <h5 className="text-p-bold text-uppercase mt-4" style={{ color:'#0079AF',marginBottom: '10px' }}>Key Points</h5>
                                {/* <ul style={{ paddingLeft: '20px', margin: 0 }}>
                                        {tableData.map((item, index) => (
                                            <li key={index} style={{ marginBottom: '8px', listStyleType: 'disc' }}>
                                                {item.text}
                                            </li>
                                        ))}
                                    </ul> */}
                                <table style={{ paddingLeft: '20px', margin: 0 }}>
                                    <tbody>
                                        {tableData.map((item, index) => (
                                            <tr key={index} style={{ marginBottom: '10px',listStyleType: 'disc' }}>
                                                <td style={{ verticalAlign: 'top',paddingRight: '10px' }}>•</td>
                                                <td>{item.text}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div style={{backgroundColor:'blue'}}></div>
                    </div>
                </React.Fragment>
            </div>)
    }
}



export default PatientCheckList_preview;